import { Button, Modal } from 'components/ui'
import { t } from 'lib/i18n'

/** Shown over the current page (Figma: System / 46 · Session expired) instead of a silent sign-out,
 *  so the user understands why before being sent back to /login. Either action just signs out —
 *  App.tsx's RequireAuth then redirects to /login with the current path, so signing back in returns here. */
export const SessionExpiredModal = ({ onDismiss }: { onDismiss: () => void }) => (
  <Modal
    title={t('انتهت صلاحية الجلسة', 'Session expired')}
    onClose={onDismiss}
    footer={
      <Button variant="primary" onClick={onDismiss}>
        {t('تسجيل الدخول مجدداً', 'Sign in again')}
      </Button>
    }
  >
    <p>
      {t(
        'لأسباب أمنية، تم تسجيل خروجك تلقائياً بعد فترة من عدم النشاط. سجّل الدخول مجدداً للمتابعة من حيث توقفت.',
        'For security, you were signed out after a period of inactivity. Sign in again to continue where you left off.'
      )}
    </p>
  </Modal>
)
